export default __webpack_public_path__ + "static/media/suite-montanha2-2.d284d93d.jpg";